import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Utilities from '@/Utility/Utilities';

export default class CallFktBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.callFkt = {
            init: (element: HTMLElement, valueAccessor: () => string) => {
                let value = valueAccessor();

                if (Utilities.isFunction(value)) {
                    value();
                }
            }
        };
    }
}